// extracted by mini-css-extract-plugin
module.exports = {"BlogPost":"BlogPost_BlogPost__2mFMB"};